export default __webpack_public_path__ + "static/media/Paypal.58022c83.svg";